import { useState } from "react";
import canUseDOM from "dom-helpers/canUseDOM";
import { createPortal } from "react-dom";
const Portal = (props)=>{
    const { children  } = props;
    const [container] = useState(()=>{
        if (!canUseDOM) return null;
        return document.body;
    });
    if (!container) return null;
    return /*#__PURE__*/ createPortal(children, container);
};
export default Portal;
